<template>
    <multiselect
        v-model="periodicity"
        :options="periodicityOptions"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="!!allowEmpty"
        placeholder="Periodicidad"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {periodicityOptions} from '@/constants/fee-type-constants';

    export default {
        name: "PeriodicityMonthsSelector",
        components: {
            Multiselect
        },
        props: {
            value: Number,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                periodicity: !!this.value ? this.findPeriodicityByKey(this.value) : null
            }
        },
        computed: {
            periodicityOptions() {
                return periodicityOptions;
            }
        },
        methods: {
            findPeriodicityByKey(key) {
                return periodicityOptions.find(periodicity => (periodicity.key === key));
            },
            notifyChange(periodicity) {
                this.$emit('input', (!!periodicity ? periodicity.key : null));
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.periodicity = this.findPeriodicityByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>